
import Vue, { defineComponent } from "vue";
export default defineComponent({
  name: "sportsSvg",
  components: {},
  props: {
    color: {
      type: String,
      default: "red",
    },
  },
});
